export const queryKeys = {
  JOB_ALL_FILES:"JOB_ALL_FILES",
  JOB_PROGRESS_FILES:"JOB_PROGRESS_FILES"
};
